var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconOnlyPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2536_2768)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.123 271.587C516.123 271.587 602.06 173.768 704.677 108.645C792.662 52.8123 885.111 25.2048 899.587 28.233C914.062 31.2612 1028.26 172.658 1030.94 394.321C1034.84 716.256 851.199 853.939 761.878 910.654C631.105 993.689 518.242 988.95 518.242 988.95C518.242 988.95 357.105 993.24 213.166 872.564C12.4002 704.246 -25.6876 470.929 14.024 280.052C41.8715 146.182 117.327 27.8163 130.546 26.1172C143.765 24.418 221.99 40.8219 319.094 100.182C415.841 159.323 516.123 271.587 516.123 271.587ZM527.216 832.388C527.216 770.742 470.04 645.971 415.239 540.275C344.912 404.635 236.14 293.98 194.099 277.934C196.064 273.783 291.73 412.641 374.179 565.728C458.475 722.245 518.155 895.603 518.242 902.189C518.242 902.189 527.216 894.033 527.216 832.388ZM573.325 582.656C569.62 588.127 576.18 683.73 590.273 735.017C604.554 786.975 660.745 831.922 704.677 790.036C758.059 739.139 675.018 667.3 675.018 667.3C675.018 667.3 577.03 577.184 573.325 582.656ZM573.325 517.057C573.726 506.186 702.559 495.895 702.559 495.895C702.559 495.895 796.5 486.884 795.776 559.379C788.138 624.072 683.497 584.772 683.497 584.772C683.497 584.772 572.902 528.524 573.325 517.057ZM577.562 438.76C581.536 450.814 712.094 413.856 730.1 402.786C742.697 395.04 837.73 344.057 797.895 286.4C758.059 228.742 680.213 297.502 668.661 307.561C657.109 317.621 569.383 425.05 577.562 438.76Z",
    fill: "url(#paint0_linear_2536_2768)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2536_2768",
    x1: 920.328,
    y1: 66.805,
    x2: 164.627,
    y2: 945.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8479A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2536_2768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconOnlyPink);
export default __webpack_public_path__ + "static/media/logo-icon-only-pink.737139e5653e3e263d0c5634d627f895.svg";
export { ForwardRef as ReactComponent };